import { memoize } from '@/utils/memoize-util'

const moneyFormatter = new Intl.NumberFormat('en-US', {
  currency: 'usd',
  style: 'currency',
})

/**
 * Formats the given value as USD currency.
 */
export function formatMoney(money: number, displaySign = false) {
  if (displaySign && money > 0) {
    return '+' + moneyFormatter.format(money)
  }

  return moneyFormatter.format(money)
}

/**
 * Gets a currency symbol for its corresponding currency code.
 */
export const getCurrencyCode = memoize(function (code: string) {
  return Intl.NumberFormat('en-US', {
    currency: code,
    style: 'currency',
  })
    .formatToParts(0)
    .find((p) => p.type === 'currency')?.value
})
